<script lang="ts" setup>
	import CommonConfirmButton from '@/components/common/ConfirmButton.vue'

	defineOptions({ inheritAttrs: false })

	interface Props {
		modal?: boolean
		title?: string
		text?: string
		confirmOnEnter?: boolean | string
	}

	withDefaults(defineProps<Props>(), {
		modal: false,
		title: '',
		text: '',
		confirmOnEnter: false,
	})

	defineEmits(['confirm'])
</script>

<template>
	<CommonConfirmButton
		v-bind="$attrs"
		:modal="modal"
		:title="title"
		:text="text"
		:confirm-on-enter="confirmOnEnter"
		@confirm="$emit('confirm')">
		<slot />
	</CommonConfirmButton>
</template>
